<template>
    <div class="plan-switch mt-4 mx-auto">
        <div
            class="bg-white border-2 border-gray-200 rounded-full mb-6 flex relative hoover:drop-shadow-md mx-auto max-w-xs px-3 py-2 gap-2 items-center justify-center">
            <button @click="SwitchType('monthly')"
                class="rounded-full hover:text-main transition-color duration-200 my-1 py-1 relative  flex-shrink-0 w-36"
                :class="{ 'text-main': type == 'monthly' }">
                <div v-if="type == 'monthly'"
                    class="absolute top-0 w-full h-full rounded-full left-0 bg-success "></div>
                <span class="relative z-10 p-2 text-base font-semibold whitespace-nowrap py-2 md:py-4" :class="{'text-white':type=='monthly'}">⚡ {{ $t('monthly') }}</span>
            </button>
            <button @click="SwitchType('annually')" :class="{ 'text-main': type == 'annually' }"
                class="rounded-full hover:text-main transition-color duration-200 py-1 my-1 relative flex-shrink-0 w-36">
                <div v-if="type == 'annually'"
                    class="absolute top-0 w-full h-full rounded-full  left-0 bg-success "></div>
                <span class="relative z-10 p-2 text-base font-semibold whitespace-nowrap py-2 md:py-4"  :class="{'text-white':type=='annually'}">🔥 {{ $t('annually') }}</span>
            </button>
        </div>
    </div>
</template>
<script setup >
const emit = defineEmits()

const props = defineProps({
    type: {
        type: String,
        required: true
    }
})
const SwitchType = (t) => {
    emit('changeType', t)
}
</script>